import { Reducer } from "redux";
import * as Actions from "./actions";
import { ActionTypes } from "./action-types";

export interface ISpotlightState {
    isLoading: boolean;
    items: Spintr.SpotlightNewsArticle[];
}

const initialState: ISpotlightState = {
    isLoading: true,
    items: [],
};

const spotlightReducer: Reducer<ISpotlightState, Actions.SpotlightAction> = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.FetchSpotlightFulfilled:
            return {
                ...state,
                items: action.payload.data,
                isLoading: false,
            };

        case ActionTypes.RemoveSpotlightItem:
            return {
                ...state,
                items: state.items.filter(item => item.id !== action.payload),
            };

        case ActionTypes.ClearSpotlight:
            return initialState;

        default:
            return state;
    }
};

export default spotlightReducer;